import ReembolsoService from "@/services/reembolso.service";

export default {
  namespaced: true,
  state: {
    reembolso: null,
    reembolsos: [],
    loading: false,
    error: null,
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setReembolsos: (state, reembolsos) => state.reembolsos = reembolsos,
    setReembolso: (state, reembolso) => state.reembolso = reembolso,
  },
  actions: {
    async ['buscaReembolso']({ commit },
      {
        uf,
        produto,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        credenciado,
        planos,
        administradora,
        entidade
      }
    ) {
      try {
        commit("setLoading", true);
        const data = await ReembolsoService.busca(
          uf,
          produto,
          tipo_plano,
          contratacao,
          cidade,
          compulsorio,
          coparticipacao,
          acomodacao,
          credenciado,
          planos,
          administradora,
          entidade
        )
        commit("setReembolsos", data);
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getReembolso: state => state.reembolso,
    getReembolsos: state => state.reembolsos,
  }
};
